import { FC } from 'react';

import { RootState } from 'store/rootReducer';

import { useAppSelector } from 'hooks/defaultStoreHooks';

import { RaaDialog } from 'raa-react';

const CreateUtkastDialog: FC<{
  createUtkast: (lmRegisterbyggnadId: string, aktivitetId: string) => Promise<void>;
  lmRegisterbyggnadId: string;
  aktivitetId: string;
  unsetDialog: () => void;
}> = ({ createUtkast, aktivitetId, lmRegisterbyggnadId, unsetDialog }) => {
  const { requestStatus: utkastRequestStatus, requestType } = useAppSelector((state: RootState) => state.utkast);

  return (
    <RaaDialog
      proceed={async () => {
        await createUtkast(lmRegisterbyggnadId, aktivitetId);
        unsetDialog();
      }}
      close={unsetDialog}
      cancel={unsetDialog}
      header={'Skapa ytterligare objekt i samma byggnad?'}
      proceedButtonText={'skapa'}
      cancelButtonText={'avbryt'}
      showLoadingSpinner={(requestType === 'post' || requestType === 'patch') && utkastRequestStatus === 'pending'}
      ariaDescribedBy="dialog-description"
    >
      <p id="dialog-description" className="tw-mt-8">
        Det finns redan ett objekt i Bebyggelseregistret. Om du istället vill välja det objektet, välj
        &quot;Avbryt&quot; och klicka på kartnålen.
      </p>
    </RaaDialog>
  );
};

export default CreateUtkastDialog;
